/**
 * Client-side filtering for item price overrides (y-adjusted pricing).
 * The yadjustedPricing API has no server-side filtering, so the data provider
 * applies these predicates to the rows it fetches (see dataProvider.ts).
 */
import type { YAdjustedRow } from './types';

export interface OverrideFilters {
  searchQuery?: string;
  department?: string;
  category?: string;
  color?: string;
  sizeCode?: string;
  yadjustedCode?: string;
}

export const filterOverrideRows = (rows: YAdjustedRow[], filters: OverrideFilters): YAdjustedRow[] =>
  rows.filter((row) => {
    if (filters.searchQuery) {
      const query = filters.searchQuery.toLowerCase();
      const haystack = [row.parentSku, row.skuSubcode, row.title].map(value => (value ?? '').toLowerCase());
      if (!haystack.some(value => value.includes(query))) return false;
    }
    if (filters.department && row.department !== filters.department) return false;
    if (filters.category && row.category !== filters.category) return false;
    if (filters.color && !(row.color ?? '').toLowerCase().includes(filters.color.toLowerCase())) return false;
    if (filters.sizeCode && !(row.sizeCode ?? '').toLowerCase().includes(filters.sizeCode.toLowerCase())) return false;
    if (filters.yadjustedCode && !(row.yadjustedCode ?? '').toLowerCase().includes(filters.yadjustedCode.toLowerCase())) return false;
    return true;
  });
